import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Batch } from '../models';
import { DirectoryApi } from './directory.api';

@Injectable()
export class BatchService extends DirectoryApi<Batch> {
  batches: any;
  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('batches', http, roleService, uxService);
  }
}
